export default "__VITE_ASSET__240efc67__"